import { getAllConnections } from "../APICalling/ServiceAPICalling";
import { checkServiceAuth } from "../APICalling/UserInvitationApiCalling";
import {
  checkZohoAuth,
  getAllActiveUsersAndCurrentUser,
  getOrgVariable,
  setOrgId,
  setUpDataCenter,
  setUpDataCenterUrl,
  setUpOrgVariable,
} from "../APICalling/ZohoAPICalling";
import {
  API_KEY_API_NAME,
  CREDENTIAL_OF_LOGIN_USER_SERVICE_API_NAME,
  CREDENTIAL_OF_LOGIN_USER_ZOHO_API_NAME,
  ORG_ID_API_NAME,
  SERVICE_API_KEY_API_NAME,
  SERVICE_AUTHENTICATION_TYPE,
  SERVICE_CONN,
  ZOHO_CONN,
  Z_API_KEY_API_NAME,
} from "../config/serviceConstant";
const ZOHO = window.ZOHO;

const authCheckZoho = async ({ orgId, apiKey, dataCenterUrl }) => {
  try {
    if (!orgId || !apiKey || !dataCenterUrl) {
      return false;
    }
    const zohoHeaders = {
      orgid: orgId,
      connname: ZOHO_CONN,
      apikey: apiKey,
      datacenterurl: dataCenterUrl,
    };
    return await checkZohoAuth(zohoHeaders);
  } catch (error) {
    return false;
  }
};

const authCheckService = async ({ ZOHO, orgId, apiKey }) => {
  try {
    if (!orgId || !apiKey) {
      return false;
    }
    const serviceHeaders = {
      orgId: orgId,
      connname: SERVICE_CONN,
      apiKey: apiKey,
    };
    let serviceToken = await checkServiceAuth(serviceHeaders);
    if (SERVICE_AUTHENTICATION_TYPE == "apikey") {
      // Set apikey in variable
      await setUpOrgVariable(ZOHO, SERVICE_API_KEY_API_NAME, serviceToken);
      return true;
    }
    return true;
  } catch (error) {
    return false;
  }
};

export async function initRelatedListZoho(callback) {
  try {
    ZOHO.embeddedApp.on("PageLoad", async function () {
      let extensionData = {};

      const orgId = await getOrgVariable(ZOHO, ORG_ID_API_NAME);
      const apiKey = await getOrgVariable(ZOHO, API_KEY_API_NAME);
      const zApiKey = await getOrgVariable(ZOHO, Z_API_KEY_API_NAME);
      const credentialOfLoginUserZoho = await getOrgVariable(
        ZOHO,
        CREDENTIAL_OF_LOGIN_USER_ZOHO_API_NAME
      );
      const credentialOfLoginUserService = await getOrgVariable(
        ZOHO,
        CREDENTIAL_OF_LOGIN_USER_SERVICE_API_NAME
      );

      const { allUsers, currentUser } = await getAllActiveUsersAndCurrentUser(
        ZOHO
      );

      const serviceApiKey = await getOrgVariable(
        ZOHO,
        SERVICE_API_KEY_API_NAME
      );

      const dataCenterUrl = await setUpDataCenterUrl(ZOHO);
      const dataCenter = await setUpDataCenter(ZOHO);

      extensionData["credentialOfLoginUserZoho"] = credentialOfLoginUserZoho;
      extensionData["credentialOfLoginUserService"] =
        credentialOfLoginUserService;

      let authenticatedUserMap = {};
      try {
        let tempConnName =
          process.env.REACT_APP_EXTENSION_IDENTIFIER + "__predefined";
        let headers = {
          orgId,
          apiKey,
          dataCenterUrl,
          dataCenter,
          zApiKey,
          connName: tempConnName,
        };
        const connectionList = await getAllConnections({ headers });

        connectionList.forEach((connection) => {
          let authenticatedService = connection?.service_name?.substring(
            orgId?.length + tempConnName?.length + 4
          );
          let serviceName = authenticatedService?.split("__")?.[0];
          let userEmail = authenticatedService?.split("__")?.[0];
          let service = authenticatedUserMap?.[serviceName] || [];
          service.push(userEmail);
          authenticatedUserMap = {
            ...authenticatedUserMap,
            [serviceName]: service,
          };
        });
      } catch (error) {}

      extensionData["zohoAuth"] = false;
      if (credentialOfLoginUserZoho != "OFF") {
        let serviceHeaders = {
          orgId,
          apiKey,
          dataCenterUrl,
          dataCenter,
          zApiKey,
          connName:
            process.env.REACT_APP_EXTENSION_IDENTIFIER +
            "__predefined__zoho__" +
            currentUser?.email,
        };
        extensionData["zohoAuth"] = await checkServiceAuth(serviceHeaders);
      } else if (authenticatedUserMap?.zoho?.length > 0) {
        extensionData["zohoAuth"] = true;
      }

      extensionData["serviceAuth"] = false;
      if (credentialOfLoginUserService != "OFF") {
        let serviceHeaders = {
          orgId,
          apiKey,
          dataCenterUrl,
          dataCenter,
          zApiKey,
          connName:
            process.env.REACT_APP_EXTENSION_IDENTIFIER +
            "__predefined__sharepoint__" +
            currentUser?.email,
        };
        extensionData["serviceAuth"] = await checkServiceAuth(serviceHeaders);
      } else if (authenticatedUserMap?.sharepoint?.length > 0) {
        extensionData["serviceAuth"] = true;
      }
      // extensionData["serviceAuth"] = await authCheckService({
      //   ZOHO: ZOHO,
      //   orgId,
      //   apiKey,
      // });

      extensionData["orgId"] = orgId;
      extensionData["apiKey"] = apiKey;
      extensionData["dataCenterUrl"] = dataCenterUrl;
      extensionData["dataCenter"] = dataCenter;
      extensionData["zApiKey"] = zApiKey;
      extensionData["serviceApiKey"] = serviceApiKey;
      extensionData["allUsers"] = allUsers;
      extensionData["currentUser"] = currentUser;

      extensionData["zohoLoaded"] = true;
      callback(null, extensionData);
    });
    ZOHO.embeddedApp.init().then(() => {});
  } catch (initZohoError) {
    callback(initZohoError, null);
  }
}
